import { animate, inView } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    // Select all the component-picture elements
    const componentPicture = document.querySelectorAll('.component-picture');

    // Check if there are no component-picture
    if (componentPicture.length === 0) {
        return;
    }

    // Loop through each section
    componentPicture.forEach((component) => {
        const fadeAnimations = component.querySelectorAll('.fade-in, .fade-up, .fade-down, .fade-left, .fade-right');

        fadeAnimations.forEach((picture, index) => {
            let transformValue = '';
            if (picture.classList.contains('fade-up')) {
                transformValue = 'translateY(60px)';
            } else if (picture.classList.contains('fade-down')) {
                transformValue = 'translateY(-60px)';
            } else if (picture.classList.contains('fade-left')) {
                transformValue = 'translateX(60px)';
            } else if (picture.classList.contains('fade-right')) {
                transformValue = 'translateX(-60px)';
            }

            inView(picture, () => {
                animate(picture, 
                    { 
                        opacity: [0, 1], 
                        transform: [transformValue || 'translateY(0)', 'translateY(0)'],
                    },
                    { 
                        duration: 0.6, 
                        delay: 0.125 * index, 
                        once: true  // Ensures the animation only triggers once
                    }
                );
            });
        });
    });
});